import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { PaymentMethod } from '../../entities';

const actionFeatureKey = 'Payment Methods';

export const loadPaymentMethods = createAction(`[${actionFeatureKey}/API] Load Payment Methods`);
export const loadPaymentMethodsSuccess = createAction(
    `[${actionFeatureKey}/API] Load Payment Methods Success`,
    props<{ paymentMethods: PaymentMethod[] }>()
);
export const loadPaymentMethodsFailure = createAction(
    `[${actionFeatureKey}/API] Load Payment Methods Failure`,
    props<{ error: HttpErrorResponse }>()
);
